import type { PortalData } from '../generated/api';
import config from '../config';
import LocalStorage from './LocalStorage';

export const PORTAL_DATA_KEY = 'portal-data';

async function warm() {
  const url = `${config.PROTOCOL}://${config.API_URL}/api/portal-data`;
  let data: PortalData | undefined = undefined;

  try {
    const res = await fetch(url);
    if (res.status !== 200 && res.status !== 304) {
      throw new Error();
    }
    data = await res.json();
  } catch (err) {
    return;
  }

  LocalStorage.set(LocalStorage.Keys.PortalData, data);
  return data;
}

(window as any).careand_warmup = warm();

export const getPortalData = () => LocalStorage.get(LocalStorage.Keys.PortalData);
